export default __webpack_public_path__ + "static/media/img-press-release-providing.08ebf446.jpg";